export default "__VITE_ASSET__DsAABxEb__"